var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gw",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h160v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M160 0h352v256H160z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M160 256h352v256H160z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.2 72.8) scale(.7886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "matrix(80 0 0 80 160 240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(72 160 240)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(144 160 240)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144 160 240)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72 160 240)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGw);
export default __webpack_public_path__ + "static/media/gw.0ea1dd3cdb1947432fa798a5901ae700.svg";
export { ForwardRef as ReactComponent };